import React from "react";
import { REGENERUS_TERMS_OF_USE_SLUG } from "@/core/urls";
import PolicyPage from "./PolicyPage";

function RegenerusTermsOfUsePage() {
  return <PolicyPage slug={REGENERUS_TERMS_OF_USE_SLUG} />;
}

export default RegenerusTermsOfUsePage;
